var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFireIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9735 15.4667C18.8802 10.0267 11.4268 9.73336 13.2268 1.82669C13.3602 1.24002 12.7335 0.786691 12.2268 1.09336C7.38683 3.94669 3.90683 9.66669 6.82683 17.16C7.06683 17.7734 6.34683 18.3467 5.82683 17.9467C3.4135 16.12 3.16016 13.4934 3.3735 11.6134C3.4535 10.92 2.54683 10.5867 2.16016 11.16C1.2535 12.5467 0.333496 14.7867 0.333496 18.16C0.840163 25.6267 7.14683 27.92 9.4135 28.2134C12.6535 28.6267 16.1602 28.0267 18.6802 25.72C21.4535 23.1467 22.4668 19.04 20.9735 15.4667ZM8.60016 22.1734C10.5202 21.7067 11.5068 20.32 11.7735 19.0934C12.2135 17.1867 10.4935 15.32 11.6535 12.3067C12.0935 14.8 16.0135 16.36 16.0135 19.08C16.1202 22.4534 12.4668 25.3467 8.60016 22.1734Z",
    fill: "#03CDEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/FireIcon.471f1c1c8ff68597bd77fdff534feb03.svg";
export { ForwardRef as ReactComponent };